import React, { Component } from 'react';
import { connect } from 'react-redux';
import { hideShadowsModal } from '../../../store/actions/shadows';
import NavigationClose from 'material-ui/svg-icons/navigation/close';
import { contrastFromHex } from '../../../helpers/colors';
import { getFontGoogleCodeName } from '../../../helpers/fonts';
const ESCAPE_KEY = 27;
import './ShadowsModal.css';

const mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    hideShadowsModal: () => {
      dispatch(hideShadowsModal());
    },
  }
}

const mapStateToProps = (state) => {
  return {
    shadowsObj: state.shadowsObj,
  }
}

class ShadowsModal extends Component {
  constructor(props) {
    super(props);
    this.handleKeyDown = this.handleKeyDown.bind(this)
  }

  handleKeyDown (event) {
    switch( event.keyCode ) {
      case ESCAPE_KEY:
        event.preventDefault();
        this.props.hideShadowsModal();
        break;
      default:
        break;
    }
  }

  componentWillMount(){
    document.addEventListener("keydown", this.handleKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown);
  }

  render () {
    const {
      shadowsObj
    } = this.props;
    console.log(shadowsObj);

    const {
      background,
      textShadowColor,
      color,
      fontFamily,
      shadowAngle,
      shadowLength,
      offset,
      offsetShadow
    } = shadowsObj;

    let max = 30;
    if (shadowLength)
      max = shadowLength;
    let textShadowString = textShadowColor + ' 1px 1px,';
    for (let i = 0; i < max; i++) {
      if (shadowAngle === 'right')
        textShadowString += textShadowColor + ' ' + i + 'px ' + i + 'px,';
      else if (shadowAngle === 'left')
        textShadowString += textShadowColor + ' -' + i + 'px ' + i + 'px,';
    }
    textShadowString = textShadowString.replace(/,$/,"");


    if (offset) {
      textShadowString = offsetShadow
    }

    return (
      <div className="shadows-modal-background"
        style={{
          background: background
        }}>
        <div className="shadows-modal-wrapper">
          <div className="close-shadows-modal-container"
            onClick={this.props.hideShadowsModal}>
            <NavigationClose className="close-shadows-modal-container-icon"
              style={{
                color: contrastFromHex(background)
              }} />
          </div>
          <div className="shadows-modal-header"
            style={{
              color: contrastFromHex(background)
            }}>
            Copy the CSS:
          </div>
          <div className="shadows-modal-css-container"
            style={{
              background: textShadowColor,
              color: color,
            }}>
            background: {background};<br />
            color: {color}; <br />
            font-family: '{fontFamily}'; <br />
            text-shadow: {textShadowString};

          </div>
          <div className="shadows-modal-font-family"
            style={{
              color: contrastFromHex(background)
            }}>
            Looking for the font {fontFamily}? Find it on <a href={'https://fonts.google.com/specimen/' + getFontGoogleCodeName(fontFamily)} target="_blank">Google Fonts</a>.
          </div>
        </div>
      </div>
    )
  }
}

export default ShadowsModal = connect(mapStateToProps, mapDispatchToProps)(ShadowsModal);



// WEBPACK FOOTER //
// ./src/pages/projects/shadows/ShadowsModal.jsx